export default {
    navigation: {
        info: "Sobre",
        open_calls: "Open Calls",
        spaces: "Espaços & Reserva",
        classes: "Práticas",
        blog: "Bookmarks",
        artists: "Comunidade",
        login: "Login",
        account: "Conta",
    },
    calendar: {
        artistic: "Residências Artísticas",
        technical: "Residências Técnicas",
        reclamar_tempo: "Reclamar Tempo",
        residences: "Residências Cruzadas",
        reservation: "Reserva de Espaços",
        lesson: "Práticas",
        public: "Outros",
    },
    footer: {
        informations: "Informações",
        subscribe_newsletter: "Subscrever a newsletter",
        privacy_policy: "Política de Privacidade",
        cookies_policy: "Política de Cookies",
        terms_use: "Termos e condições",
        links: "Links",
        facebook: "Facebook",
        instagram: "Instagram",
        newsletter: "Newsletter",
        emails: "Email",
        address: "Morada",
        phone: "Telefone",
    },
    login: {
        register: "Registo",
        login: "Login",
        intro: "Olá! Insira os seus dados de acesso.",
        email: "Email",
        email_placeholder: "Email",
        password: "Palavra-passe",
        password_placeholder: "Palavra-passe",
        recover: "Recuperar palavra-passe",
        signIn: "Entrar",
        confirm_password_placeholder: "Confirmar palavra-passe",
        error: "Utilizador não encontrado",
    },
    classes: {
        with: "c/",
        online: "[Aula Online]",
        local: "Espaço",
        price: "Preço",
        level: "Nível",
        level_1: "Iniciado",
        level_2: "Intermédio",
        level_3: "Avançado",
        free: "Gratuito",
        buy: "Comprar",
        see_more: "Ver mais",
        see_less: "Ver menos",
        see_details: "Ver Detalhes",
        close_details: "Fechar Detalhes",
        reserve: "Reservar",
        conditions: "Condições de admissão",
        practice: "prática",
        practices: "práticas",
    },
    recover: {
        register: "Register",
        login: "Login",
        back: "Voltar para login",
        intro: "Ao inserir o seu email, irá receber um email com os passos para recuperar a sua palavra-passe.",
        submit: "Recuperar palavra-passe",
        success: "Email enviado com sucesso",
        error: "Ocorreu um erro ao recuperar a palavra-passe. Por favor, tente novamente mais tarde.",
    },
    newsletter: {
        button: "Subscrever Newsletter",
        text: "Subscrevam a nossa mailing list e recebam todas as novidades sobre o CAMPUS Paulo Cunha e Silva.",
        placeholder: "Insira o seu email",
        success: "Obrigado por subscrever a nossa newsletter. Por favor, confirme esta subscrição no seu e-mail.",
    },
    cookies: {
        button: "Aceito",
        text: "Este site utiliza cookies para melhorar a sua experiência. Ao clicar em Aceitar está a concordar com a nossa",
        text_privacy: "Política de Cookies",
    },
    validation: {
        completed: "completo",
        required: "Este campo é obrigatório",
        email: "O email não é válido",
        optional: " (opcional)",
        date: "Data não é válida",
        max_chars: (value) =>
            "O campo deve ter no máximo " + value + " caracteres",
        min: (value) => "Deve selecionar pelo menos " + value,
        max: (value) => "Deve selecionar no máximo " + value,
        equal: (value) => "Só deve selecionar " + value,
        min_slots: "Deve selecionar no mínimo 4 horas",
        min_string: (min) =>
            "O campo deve ter pelo menos " + min + " caracteres",
        confirm: "A palavra-passe não é igual",
        email_exists: "Este email já está a ser utilizado",
        register_error:
            "Ocorreu ao erro ao fazer o registo. Por favor, tente novamente mais tarde.",
        booking_slots:
            "Reservas devem ter sempre pelo menos 4 slots consecutivas",
    },
    account: {
        my_account: "Minha conta",
        logout: "Sair",
        profile: "Perfil",
        artistic: "Residências Artísticas",
        technical: "Residências Técnicas",
        reclamar_tempo: "Reclamar Tempo",
        reservation: "Reserva de Espaços",
        history: "Histórico de reservas",
        application_history: "Histórico de candidaturas",
        edit: "Editar",
        blocked: "Neste momento, não é possível fazer reservas através deste perfil. Para mais informações, contacte-nos por e-mail: ",

        delete_account: "Eliminar Conta",
        delete_account_text: "Tem a certeza que quer eliminar a sua conta?",

        name: "Nome",
        email: "Email",
        type: "Estrutura",
        password: "Palavra-Passe",
        gender: "Género",
        birthday: "Data de Nascimento",
        nationality: "Nacionalidade",
        address: "Morada",
        postal_code: "Código Postal",
        city: "Cidade",
        district: "Distrito",
        country: "País",
        vat: "Número de Contribuinte",
        phone: "Número de Telemóvel",
        website: "Website",
        biography: "Biografia",
        photo: "Fotografia",

        edit_title: "Editar Dados",

        available_quota: "horas disponíveis",
        quota_empty: (days) =>
            "Esgotou o seu banco de horas.Este banco de horas será renovado daqui a " +
            days +
            " dias!",

        button_application: "Formulário de candidatura",
        button_rules: "Regulamento",
        button_soon: "Brevemente",
        button_mentors: "Acomp. Crítico",
        button_external: "Olhares externos",
        button_jury: "Júri",
        button_booking: "Reservar",
        button_terms: "Termos e condições",
        button_faqs: "FAQs",
        button_add_pdf: "Adicionar PDF",
        button_remove_pdf: "Remover PDF",
        button_save: "Gravar",

        faq_1: "Residências",
        faq_2: "Reclamar Tempo",
        faq_3: "Reserva de Espaços",

        artistics_type: "CANDIDATURA RESIDÊNCIAS ARTÍSTICAS",
        technics_type: "CANDIDATURA RESIDÊNCIAS TÉCNICAS",
        claim_type: "CANDIDATURA RECLAMAR TEMPO",
        space_type: "RESERVA DE ESPAÇO",
    },
    artistic_booking: {
        title: "Residências Artísticas Candidatura",
        submit: "Submeter",
        success: "A sua candidatura foi submetida com sucesso.",
        success_button: "Ok, obrigado!",
        error: "Ocorreu um erro. Por favor, tente novamente mais tarde.",
        max_chars: (value) => "[máx. " + value + " caracteres incl. espaços]",

        confirm_title: "Confirmar Candidatura",
        confirm_text: "Tem a certeza que quer confirmar esta candidatura?",

        cancel_title: "Cancelar Candidatura",
        cancel_text: "Tem a certeza que quer cancelar esta candidatura?",

        step_1_email_title: "Insira os seguintes dados.",
        step_1_email_placeholder: "Email",
        step_1_phone_placeholder: "Contacto Telefónico",
        step_1_name_placeholder: "Nome artista/coletivo/entidade candidata",
        step_1_type_placeholder:
            "Tipo de estrutura (coletivo, artista individual, etc)",
        step_1_terms_title: "Li e entendi os termos e condições da open call.",

        step_2_birthday_title: "Data de nascimento (se aplicável)",
        step_2_birthday_placeholder: "DD-MM-AAAA",
        step_2_gender_title: "Indique o género",
        step_2_gender_op_1: "Masculino",
        step_2_gender_op_2: "Feminino",
        step_2_gender_op_3: "Não Binário/Outro",
        step_2_gender_op_4: "Prefiro não dizer",

        step_3_address_title: "Insira os seguintes dados fiscais.",
        step_3_address_placeholder: "Morada",
        step_3_postal_placeholder: "Código Postal",
        step_3_city_placeholder: "Cidade",
        step_3_district_placeholder: "Distrito",
        step_3_country_placeholder: "País",
        step_3_nif_placeholder: "NIF",
        step_3_nationality_placeholder: "Nacionalidade",
        step_3_photo_placeholder: "Foto ID",
        step_3_tax_proof_placeholder: "Comprovativo de Residência Fiscal",
        step_3_tax_proof_help:
            "As pessoas titulares das candidaturas devem fazer prova do seu domicílio, sob pena de exclusão, mediante o envio de comprovativo de domicílio fiscal, i.e., certidão emitida pelo Portal da Autoridade Tributária e Aduaneira (ou documento equivalente em caso das candidaturas estrangeiras). Em caso de pessoas coletivas, deverá ser apresentada a cópia do Cartão de Pessoa Coletiva (ou documento equivalente em caso das candidaturas estrangeiras).",

        step_4_website_title: "Links de uso profissional",
        step_4_website_placeholder: "Website (opcional)",
        step_4_facebook_placeholder: "Facebook (opcional)",
        step_4_instagram_placeholder: "Instagram (opcional)",
        step_4_vimeo_placeholder: "Vimeo (opcional)",
        step_4_youtube_placeholder: "Youtube (opcional)",

        step_5_title_title: "Fale-nos sobre o seu projeto de pesquisa.",
        step_5_title_placeholder: "Título do projeto",
        step_5_pitch_placeholder: "Link do pitch do projeto (opcional)",
        step_5_pitch_help:
            "Certifique-se de que o vídeo não requer login ou download. No caso de ser necessária uma password, indique-nos qual no campo acima (à frente do link do vídeo).",
        step_5_cover_placeholder: "Foto do Projeto",
        step_5_area_title: "Área artística",
        step_5_area_op_1: "Dança",
        step_5_area_op_2: "Teatro",
        step_5_area_op_3: "Circo Contemporâneo",
        step_5_area_op_4: "Cruzamento Disciplinares",
        step_5_area_op_5: "Formas Animadas",

        step_6_bio_title:
            "Biografia do artista / Estrutura que solicita a reserva.",
        step_6_bio_placeholder:
            "Por favor, indique o percurso profissional, bem como a formação obtida na área.",
        step_6_bio_max: "[máx. 10000 caracteres incl. espaços]",
        step_6_work_type_placeholder:
            "Tipo de trabalho a desenvolver (pesquisa, criação, ensaios, remontagem) e motivação",
        step_6_work_type_max: "[máx. 2000 caracteres incl. espaços]",
        step_6_synopsis_placeholder: "Breve sinopse do projeto a desenvolver",
        step_6_synopsis_max: "[máx. 2000 caracteres incl. espaços]",
        step_6_description_placeholder:
            "Descrição do projeto a desenvolver, contendo a contextualização do mesmo e a sua pertinência no percurso artístico",
        step_6_description_max: "[máx. 8000 caracteres incl. espaços]",
        step_6_schedule_placeholder: "Cronograma do projeto",
        step_6_schedule_max: "[máx. 2000 caracteres incl. espaços]",

        step_7_bio_placeholder: "Biografias da equipa artística",
        step_7_bio_max: "[máx. 8000 caracteres incl. espaços]",
        step_7_financing_title: "O trabalho tem outras fontes de financiamento",
        step_7_financing_op_1: "Sim",
        step_7_financing_op_2: "Não",
        step_7_financing_op_3: "Quais?",
        step_7_video_links_title:
            "Links vídeos de trabalhos anteriores / ensaios (Por favor, descrever o motivo pelo qual escolheu incluir cada vídeo. Certifique-se de que todos os vídeos são acessíveis, não requerem downloads ou login. Se uma senha for necessária, certifique-se de incluir a senha correta)",
        step_7_video_links_placeholder: "Links (Opcional)",

        step_8_team_title:
            "Indicação dos elementos da equipa presentes durante a residência",
        step_8_team_placeholder: "Nome / Função",
        step_8_hosting_title: "Indicação da necessidade de alojamento",
        step_8_hosting_subtitle:
            "O alojamento será confirmado posteriormente mediante disponibilidade da lotação (máx. 1 quarto por projeto, 2 pessoas por quarto)",
        step_8_hosting_placeholder: "Para que elementos da equipa?",
        step_8_reduced_title:
            "Indicação de elementos da equipa com mobilidade reduzida",
        step_8_reduced_placeholder: "Insira o nome dos elementos (opcional)",

        step_9_possible_dates_title: "Balizas de datas disponíveis",
        step_9_possible_dates_placeholder:
            "Por favor, indique o período de residências pretendido, no máximo de 5 opções, tendo em conta as datas",
        step_9_dramaturgists_title:
            "Outside eyes / dramaturgistas (opcional, máx. 3 nomes)",
        step_9_eco_production_title:
            "Quero candidatar-me à Bolsa de Eco-Produção",
        step_9_eco_production_subtitle:
            "Este apoio é aplicável no caso da equipa artística trabalhar a partir da cidade do Porto e ter pelo menos 1 elemento responsável pela produção e/ou gestão",

        step_10_open_placeholder:
            "Proposta prévia para momento de abertura de processo (conversa, artist talk, ensaio aberto)",
        step_10_open_max: "[máx. 2000 caracteres incl. espaços]",
        step_10_others_placeholder: "Outros",
        step_10_others_max: "[máx. 2000 caracteres incl. espaços]",
    },
    reclamar_tempo_booking: {
        title: "Reclamar Tempo Candidatura",
    },
    claim_booking: {
        title: "Reclamar Tempo Candidatura",
        submit: "Submeter",
        success: "A sua candidatura foi submetida com sucesso.",
        success_button: "Ok, obrigado!",
        error: "Ocorreu um erro. Por favor, tente novamente mais tarde.",
        max_chars: (value) => "[máx. " + value + " caracteres incl. espaços]",

        cancel_title: "Cancelar Candidatura",
        cancel_text: "Tem a certeza que quer cancelar esta candidatura?",

        step_4_synopsis_placeholder: "Breve sinopse do projeto a desenvolver",
        step_4_synopsis_max: "[máx. 2000 caracteres incl. espaços]",
        step_4_description_placeholder:
            "Descrição da pesquisa a desenvolver, contendo a temática sobre a qual se debruça a investigação",
        step_4_description_max: "[máx. 5000 caracteres incl. espaços]",
        step_4_development_placeholder:
            "De que forma esta pesquisa é importante para o desenvolvimento do seu percurso e da sua prática artística?",
        step_4_development_max: "[máx. 5000 caracteres incl. espaços]",
        step_4_concept_placeholder:
            "Explicite a importância do conceito de investigação na sua prática artística",
        step_4_concept_max: "[máx. 5000 caracteres incl. espaços]",

        step_5_bio_placeholder: "Biografias da equipa artística",
        step_5_bio_max: "[máx. 8000 caracteres incl. espaços]",
        step_5_riders_placeholder:
            "Rider técnico com contacto da pessoa responsável",
        step_5_financing_title:
            "A proposta tem outras fontes de financiamento?",
        step_5_video_links_title:
            "Links vídeos de trabalhos anteriores / ensaios (Por favor, descrever o motivo pelo qual escolheu incluir cada vídeo. Certifique-se de que todos os vídeos são acessíveis, não requerem downloads ou login. Se uma senha for necessária, certifique-se de incluir a senha correta).",
        step_5_video_links_placeholder: "Links",

        step_6_others_placeholder: "Outros",
        step_6_others_max: "[máx. 2000 caracteres incl. espaços]",
    },
    technical_booking: {
        title: "Residências Técnicas Candidatura",
        submit: "Submeter",
        success: "A sua candidatura foi submetida com sucesso.",
        success_button: "Ok, obrigado!",
        error: "Ocorreu um erro. Por favor, tente novamente mais tarde.",
        max_chars: (value) => "[máx. " + value + " caracteres incl. espaços]",

        cancel_title: "Cancelar Candidatura",
        cancel_text: "Tem a certeza que quer cancelar esta candidatura?",

        step_6_schedule_placeholder:
            "Proposta de plano de trabalho. A confirmar posteriormente pela equipa técnica do Teatro Municipal do Porto caso o projeto seja selecionado",

        step_7_riders_placeholder:
            "Technical rider with contact from the artist/company's technical director",

        step_8_hosting_subtitle:
            "O alojamento será confirmado posteriormente mediante disponibilidade da lotação (máx.4 por apartamento)",

        step_9_date_title:
            "Período de residência pretendido (indicar apenas 1 opção)",
        step_9_others_placeholder: "Outros",
        step_9_others_max: "[máx. 2000 caracteres incl. espaços]",
    },
    spaces_booking: {
        title: "Reserva de Espaço",
        submit: "Submeter",
        success:
            "A sua reserva está pendente, a aguardar por validação da equipa do CAMPUS. Irá receber um email com a confirmação e validação da sua confirmação.",
        success_button: "Ok, obrigado!",
        error: "Ocorreu um erro. Por favor, tente novamente mais tarde.",

        floor0: "Piso 0",
        floor1: "Piso 1",
        workshop: "Oficina",

        cancel_title: "Cancelar Reserva",
        cancel_text: "Tem a certeza que quer cancelar esta reserva?",
        cancel_confirm: "Sim",
        cancel_reject: "Não",

        confirm_title: "Confirmar Reserva",
        confirm_text: "Tem a certeza que quer confirmar esta reserva?",

        step_admin_title: "Introduza o ID do utilizador e o tipo de reserva.",
        step_admin_user_id_placeholder: "ID do Utilizador",
        step_admin_type_placeholder: "Tipo",

        step_1_studio_title: "Qual o espaço que pretende reservar?",
        step_1_studio_type_1: "Piso 0",
        step_1_studio_type_2: "Piso 1",
        step_1_studio_type_3: "Outros",
        step_1_studio_1: "Estúdio 1",
        step_1_studio_2: "Estúdio 2",
        step_1_studio_3: "Estúdio 3",
        step_1_studio_4: "Estúdio 4",
        step_1_studio_5: "Outros Espaços",

        step_2_description_title: "Para que efeito pretende fazer a reserva?",
        step_2_description_placeholder:
            "Por favor, identifique os motivos da reserva de espaço, mencionando o título do projeto / pesquisa a que se destina e uma breve descrição e calendarização do mesmo.",

        step_2_others_description_title:
            "Qual é o espaço que pretende reservar (sala de estar, oficina, jardim, pátios, etc)?",
        step_2_others_description_placeholder:
            "Por favor, indique qual o espaço pretendido, a data e o período de utilização.",

        step_4_team_title: "Indique o nome e função de toda a equipa presente na utilização do espaço reservado. Apenas os nomes indicados terão acesso ao CAMPUS PCS.",
        step_4_team_placeholder:
            "",

        step_5_financing_title: "O projeto tem apoio financeiro?",

        step_6_requests_title: "Tem alguma observação ou pedido especial?",
        step_6_requests_placeholder:
            "Por favor, indique o material técnico que necessita, utilização de cenografia e adereços, sapatos, etc.",
        step_6_terms_title:
            "Concordo com os Termos e Condições da Reserva de Espaços do CAMPUS.",
    },
    spaces: {
        title: "Estúdios",
        info_title: "Espaços",
        conditions_text:
            "Para além destes espaços, existem:\n– 2 quartos (suites), um em casa piso, cada um para 2 pessoas, com casa de banho privativa, podendo alojar, no total, até 4 pessoas;\n– Casas de banho e balneários coletivos em cada piso. Casa de banho e quarto de mobilidade reduzida no piso 0;\n– Possibilidade de arrumação de adereços e cenografias de pequena dimensão na sala de arrumos, para além dos cacifos existentes;\n– Vários espaços exteriores que também poderão ser utilizados.",
        visual_stories: "Percurso Acessível",
    },
    open_calls: {
        button_application_open: "Formulário de Candidatura",
        button_results: "Projetos Selecionados",
        button_rules: "Regulamento",
        button_soon: "Brevemente",
        artistics_subtitle:
            "Apoio ao desenvolvimento de projetos experimentais e inovadores no campo das Artes Visuais.",
        claim_subtitle:
            "Apoio ao desenvolvimento de projetos experimentais e inovadores no campo das Artes Visuais.",
        technics_subtitle:
            "Apoio ao desenvolvimento de projetos experimentais e inovadores no campo das Artes Visuais.",
    },
    library: {
        title: "Biblioteca",
        year: "1980/2021",
        description:
            "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonum- my nibh euismod tincidunt utlaoreet dolore maeum iriure dolor in hendrerit invulputate velit esse molestie consequat, vel illumdolopraesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.",
        see_more: "Ver mais",
    },
    info: {
        bio_name: "Paulo Cunha e Silva",
        bio_title: "Open call",
        bio_subtitle:
            "Paulo Cunha e Silva é um programa de residências artísticas para as artes na cidade do Porto.",
        mission_subtitle:
            "O CAMPUS é um novo centro de residências artísticas para as artes performativas na cidade do Porto.",
        team_title: "EQUIPA",
        project_title: "Projeto Artístico",
        project_description: "Outras utilizações do espaço",
        classes: "Práticas",
        space: "Reserva de Espaços",
        claim: "Reclamar Tempo",
        technic: "Residências Técnicas",
        artistic: "Residências Artísticas",
    },
    home: {
        blog: "Bookmarks",
        blog_filter_all: "Todos",
        blog_back: "Ir para Bookmarks",
        blog_share: "Partilhar",
        search: "Pesquisa",
        calendar: "Calendário",
        search_articles: "Artigos",
        search_artists: "Artistas",
        search_lessons: "Práticas",
        search_open_calls: "Open Calls",
        search_empty:
            "Não encontramos o que procura. Tente pesquisar usando outras palavras.",
        see_more: "Ver mais",
        calendar: "Calendário",
        calendar_schedule: "PROGRAMAS\n2023-2024",
        calendar_subtitle:
            "Os diferentes espaços do CAMPUS Paulo Cunha e Silva são utilizados por artistas das artes performativas. Neste Calendário, podem ver a ocupação diária.",
    },
    artist: {
        title: "Artista",
        contents: "Conteúdos",
        social: "Redes Sociais",
        season: "Temporada",
        project: "Projeto",
        type: "Tipo",
        types: {
            artist: "Artista",
            judge: "Júri",
            critic: "Acompanhamento Crítico",
            outside_eyes: "Olhares Externos",
        },
    },
    reset: {
        title: "Insira a sua nova password",
        submit: "Reset",
        error: "O email não está correto ou o token expirou. Por favor, tente redefinir a palavra-passe novamente.",
        success:
            "A sua palavra-passe foi alterada! Agora pode fazer login com sua nova palavra-passe.",
    },
    register: {
        register: "Registo",
        login: "Login",
        submit: "Submeter",
        success_button: "Ok, obrigado!",
        success:
            "O seu registo está pendente, a aguardar por validação da equipa do CAMPUS. Irá receber um email com a confirmação e validação do seu registo.",
        step_1_name_title:
            "Olá! Indique o nome do artista, coletivo ou entidade que pretende registar?",
        step_1_name_placeholder: "Escreva a sua resposta aqui...",

        step_2_type_title:
            "Indique qual é o tipo de estrutura (coletivo, artista individual, etc)?",
        step_2_type_placeholder: "Escreva a sua resposta aqui...",

        step_3_gender_title: "Indique qual o seu género (se aplicável).",
        step_3_gender_op_1: "Masculino",
        step_3_gender_op_2: "Feminino",
        step_3_gender_op_3: "Não Binário/Outro",
        step_3_gender_op_4: "Prefiro não dizer",

        step_4_date_title:
            "Indique a sua data de nascimento ou data de criação do coletivo/entidade.",
        step_4_date_placeholder: "DD-MM-AAAA",

        step_5_nationality_title: "Indique qual é a sua nacionalidade.",
        step_5_nationality_placeholder: "Escreva aqui a sua resposta...",

        step_6_address_title: "Indique a sua morada.",
        step_6_address_placeholder: "Morada",
        step_6_postal_placeholder: "Código Postal",
        step_6_city_placeholder: "Cidade",
        step_6_district_placeholder: "Distrito",
        step_6_country_placeholder: "País",

        step_7_nif_title: "Indique o seu número de contribuinte.",
        step_7_nif_placeholder: "Escreva aqui a seu número...",

        step_8_phone_title: "Indique o seu número de telemóvel.",
        step_8_phone_placeholder: "Escreva aqui a seu número...",

        step_9_website_title: "Fale-nos sobre o si.",
        step_9_website_placeholder: "Website ou plataforma digital...",
        step_9_bio_placeholder:
            "Biografia (por favor, indicar a experiência profissional, bem como a formação obtida na área)",
        step_9_bio_max: "[máx. 1000 caracteres incl. espaços]",
        step_9_photo_placeholder: "Fotografia",
        step_9_photo_size: "Imagem tem que ser menor que 5Mb",
        step_9_file_size: "Ficheiro tem que ser menor que 5Mb",
        step_9_photo_resolution:
            "A largura e a altura não devem exceder 2500x2500",

        step_10_email_title: "Indique o seu email e palavra-passe.",
        step_10_email_placeholder: "Email",
        step_10_password_placeholder: "Palavra-passe",
        step_10_password_confirm_placeholder: "Confirmar palavra-passe",

        step_10_terms_title:
            "Concordo com os Termos e Condições da Reserva de Espaços do CAMPUS.",
        step_10_newsletter_title:
            "Quero receber informações do CAMPUS através da Newsletter",
    },
};
